import Service from "./service";

class NotificationService extends Service {
    
  constructor(unauthorized=false) {
    super("NOTIFICATION_SERVICE", unauthorized);
  }

  getNotifications = (userId, { limit = 5, before, role } = {}) => {
    const body = {};
    if (userId) body.userId = userId;
    if (limit != null) body.limit = limit;
    if (before) body.before = before;

    const params = {};
    if (role != null && String(role).trim() !== '') {
      params.role = role;
    }

    return this.post('/notification/role', params, body, );
  };

  markAsRead = (id) => {
    return this.post(`/notification/role/read`, {}, { 
      id: id
     });
  };
} 

export default NotificationService;
